import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import classNames from "classnames";
import * as classes from "./footerTagline.module.scss";

gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function FooterTagline({ className }) {
  const taglineContainer = useRef();
  const footerPath = useRef();

  useGSAP(
    () => {
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      // Configure ScrollTrigger
      if (typeof navigator !== "undefined") {
        const isIos = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
          navigator.platform
        );
        ScrollTrigger.config({ ignoreMobileResize: true });

        if (!isIos) {
          // Reset ScrollTrigger on resize except on IOS (mobile safari navbar collapse is treated as resize)
          const resetScrolltrigger = () => {
            ScrollTrigger.refresh();
          };

          var timeId = null;
          window.addEventListener("resize", () => {
            clearTimeout(timeId);
            timeId = setTimeout(resetScrolltrigger, 1000);
          });
        }
      }

      // Set up the animation for the tagline path
      gsap.set(footerPath.current, {
        strokeDasharray: "800px",
        strokeDashoffset: "800px",
      });

      ScrollTrigger.create({
        trigger: taglineContainer.current,
        start: () => "top 100%-=5px",
        end: () => "top 100%-=50px",
        invalidateOnRefresh: true,
        onEnter: () => {
          gsap.to(footerPath.current, {
            strokeDashoffset: "0px",
            duration: reduceMotion ? 0 : 0.75,
            delay: reduceMotion ? 0 : 0.5,
          });
        },
        onLeaveBack: () => {
          gsap.set(footerPath.current, {
            strokeDashoffset: "800px",
          });
        },
        onLeave: () => {
          gsap.set(footerPath.current, {
            strokeDashoffset: "800px",
          });
        },
      });
    },
    {
      scope: taglineContainer.current,
      dependencies: [footerPath.current, taglineContainer.current],
    }
  );

  return (
    <div className={classNames(className, classes.footerTaglineWrapper)}>
      <div className={classes.footerTagline} ref={taglineContainer}>
        <p>Do something beautiful today.</p>
        <svg
          id="footersvg"
          xmlns="http://www.w3.org/2000/svg"
          width="257"
          height="101"
          viewBox="0 0 257 101"
          fill="none"
        >
          <path
            ref={footerPath}
            d="M213.579 6.2463C165.583 -2.12462 58.1695 -6.62399 12.4845 42.3459C-44.6217 103.558 126.456 105.179 191.58 95.7104C230.547 90.0453 256 76.1843 256 56.1303C256 38.8653 211.801 12.9168 131.808 17.8217"
            stroke="url(#paint0_linear_1021_296)"
            strokeWidth="2"
            strokeLinecap="round"
            id="footerpath"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1021_296"
              x1="1.00001"
              y1="16.1467"
              x2="219.536"
              y2="105.415"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C098F5" />
              <stop offset="0.5" stopColor="#FAA4CD" />
              <stop offset="1" stopColor="#FFC9A3" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
}
